export default function Spinner({ size = 20 }) {
  return (
    <span style={{
      width: size, height: size, borderRadius: '50%', display: 'inline-block',
      border: '2px solid rgba(255,255,255,0.15)', borderTopColor: 'var(--accent)',
      animation: 'spin .7s linear infinite',
    }} />
  );
}
